import { render, staticRenderFns } from "./ApproveCompany.vue?vue&type=template&id=0c2d9be4&scoped=true&"
import script from "./ApproveCompany.vue?vue&type=script&lang=js&"
export * from "./ApproveCompany.vue?vue&type=script&lang=js&"
import style0 from "./ApproveCompany.vue?vue&type=style&index=0&id=0c2d9be4&prod&lang=less&scoped=true&"
import style1 from "./ApproveCompany.vue?vue&type=style&index=1&id=0c2d9be4&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c2d9be4",
  null
  
)

export default component.exports